module.exports = __webpack_public_path__ + "media/images/checkout/pix-f1231a93e5e356ecd4ea27c008f321fc.png";